import * as tslib_1 from "tslib";
import * as React from 'react';
var styles = {
    container: {
        padding: '20px',
        color: '#2196F3',
        backgroundColor: 'white',
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        margin: '20px 0px'
    },
    title: {
        fontSize: '13px',
        color: '#424242',
        textAlign: 'left',
        textTransform: 'uppercase',
        fontWeight: 'normal'
    },
    content: {
        fontSize: '24px',
        color: '#2196F3',
        textAlign: 'center',
    }
};
var BoardyCard = /** @class */ (function (_super) {
    tslib_1.__extends(BoardyCard, _super);
    function BoardyCard(props) {
        return _super.call(this, props) || this;
    }
    BoardyCard.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, contentStyle = _a.contentStyle;
        return (React.createElement("div", { style: styles.container },
            React.createElement("label", { style: styles.title }, title),
            React.createElement("div", { style: Object.assign({}, styles.content, contentStyle) }, children)));
    };
    return BoardyCard;
}(React.Component));
export { BoardyCard };



//////////////////
// WEBPACK FOOTER
// ./src/components/BoardyCard.tsx
// module id = 310
// module chunks = 0